import React, { Component } from "react";
import { TimePicker } from "antd";
import moment from "moment";
export class TimeRange extends Component {
  onChange = (index, date) => {
    const { value, onChange } = this.props;
    const newValue = [...value];
    newValue[index] = date ? date.format("HH:mm:ss") : null;
    onChange(newValue);
  };

  render() {
    const { value } = this.props;
    return (
      <div className="time-range">
        <TimePicker
          inputReadOnly
          className="time-first"
          value={value[0] ? moment(value[0], "HH:mm:ss") : undefined}
          placeholder="--:--"
          onChange={(date) => this.onChange(0, date)}
          format="HH:mm"
        />
        <div className="separate">:</div>
        <TimePicker
          inputReadOnly
          value={value[1] ? moment(value[1], "HH:mm:ss") : undefined}
          onChange={(date) => this.onChange(1, date)}
          className="time-second"
          placeholder="--:--"
          format="HH:mm"
        />
      </div>
    );
  }
}
